import { registerPlugin } from "@capacitor/core";

export interface KeycloakPlugin {
  handleUrl(options: { url: string }): Promise<{ url: string }>;
  addListener(status: string, callback: (data: any) => void): void;
}

const Keycloak = registerPlugin<KeycloakPlugin>("Keycloak");

export default Keycloak;
